export default __webpack_public_path__ + "static/media/black_dl_icon.0d4077b9.svg";